import { useDispatch, useSelector } from "react-redux";
import Breadcrumb from "../../SharedComponents/components/Breadcrumb/Breadcrumb";
import { FontEnum } from "../../SharedComponents/utils/enums/FontEnum";
import AddCarButtonCard from "../components/HomePageComponents/AddCarButtonCard";
import NoActiveRequests from "../components/HomePageComponents/NoActiveRequests";
import BuyerLayout from "../components/Layout";
import CarImageVisualizer from "../components/HomePageComponents/CarImageVisualizer";
import { getAllActiveRequests } from "../reduxStore/entities/partRequest";
import AllActiveRequestsTable from "../components/Tables/Table/AllActiveRequestsTable";
import { useState, useEffect } from "react";
import BaseButton from "../../SharedComponents/components/Buttons/BaseButton";
import { ButtonVariantEnum } from "../../SharedComponents/utils/enums/ButtonVariantEnum";
import ButtonDownArrowIconSVG from "../assets/icons/svg/ButtonDownArrowIconSVG";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
    const fetchedUserCarsState = useSelector((state) => state.userCars.cars);

    const DEFAULT_ROWS_PER_PAGE = 15;
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [loaded, setLoaded] = useState(false);

    const fetchedActiveCarRequests = useSelector((state) => state.partRequest.allActivePartRequests);
    const count = useSelector((state) => state.partRequest.count);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(DEFAULT_ROWS_PER_PAGE);

    const filterDto = {
        limit: rowsPerPage,
        offset: page * rowsPerPage,
    };

    const [filter, setFilter] = useState(filterDto);

    useEffect(() => {
        setFilter(filterDto);
    }, [page, rowsPerPage]);

    useEffect(() => {
        setLoaded(true);
    }, [fetchedActiveCarRequests]);

    useEffect(() => {
        dispatch(getAllActiveRequests(filter));
    }, [filter]);

    if (!loaded) {
        return null;
    };

    const GetBreadcrumbEndComponent = () => {
        return (
            <BaseButton
                onClick={() => navigate('/order-part')}
                variant={ButtonVariantEnum.BLACK}
                text={"Pošalji zahtev"}
                IconComponent={ButtonDownArrowIconSVG}
            />
        );
    };

    const GetActiveRequestTable = () => {
        return (
            <AllActiveRequestsTable
                count={count}
                fetchedActiveCarRequests={fetchedActiveCarRequests}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                page={page}
                setPage={setPage}
            />
        );
    };

    const GetUnActiveRequestTable = () => {
        return (
            <NoActiveRequests />
        );
    };

    const areThereRequests = fetchedActiveCarRequests.length > 0;


    const BreadcrumbEndComponent = areThereRequests
        ? GetBreadcrumbEndComponent
        : null;

    return (
        <BuyerLayout>
            <div style={styles.breadcrumb}>
                <Breadcrumb
                    title={"Naslovna strana"}
                    breadcrumbs={[]}
                    EndComponent={BreadcrumbEndComponent}
                />
            </div>

            {
                areThereRequests
                    ? GetActiveRequestTable()
                    : GetUnActiveRequestTable()
            }


            <p style={styles.title}>
                Garaža
            </p>

            <div style={styles.carImageGrid}>

                {(fetchedUserCarsState.length > 0) && fetchedUserCarsState.map((car, index) => {
                    return (
                        <CarImageVisualizer
                            key={index}
                            car={car}
                        />
                    );
                })}

                <AddCarButtonCard />
            </div>

        </BuyerLayout>
    );
};

export default HomePage;

const styles = {
    title: {
        marginTop: 50,
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    carImageGrid: {
        marginTop: 30,
        width: "max-content",
        display: 'grid',
        gridTemplateColumns: "1fr 1fr 1fr",
        gap: 20,
    },
    breadcrumb: {
        marginBottom: 50
    }
};